<script>
import bus from "@/bus";
import features from "@/configs/features";
import { useI18n } from "vue-i18n";
import { useUserStore } from "../stores/user";
export default {
  setup() {
    const { t } = useI18n();
    const userStore = useUserStore();
    return { userStore, t };
  },
  computed: {
    routes() {
      const routes = [
        {
          to: "/",
          text: "components.navbar.home",
        },
        ...(features.LEGIS
          ? [
              {
                to: this.t("path.legis"),
                text: "components.navbar.reglementation",
              },
            ]
          : []),
        {
          to: this.t("path.faq"),
          text: "components.navbar.faq",
        },
      ];
      if (this.userStore.isAdmin === true) {
        routes.push({
          to: "/admin",
          text: "components.navbar.admin",
        });
      } else if (this.userStore.isAdminFileDownloader === true) {
        routes.push({
          to: "/admin/imported-data",
          text: "components.admin_navbar.imported_data",
        });
      } else if (this.userStore.loggedIn) {
        routes.push({
          to: this.t("path.mairie"),
          text: "components.navbar.town_hall",
        });
      }
      if (!this.userStore.loggedIn) {
        routes.push({
          to: this.t("path.signup_login"),
          text: "components.navbar.sign",
        });
      }
      return routes;
    },

    modals() {
      return [
        {
          name: "contact",
          text: "components.navbar.contact",
        },
      ];
    },
    loggedIn() {
      return this.userStore.loggedIn;
    },
  },
  methods: {
    burgerClickHandler() {
      const navLinks = document.getElementById("navbar-links");
      if (navLinks.classList.contains("hidden")) {
        navLinks.classList.remove("hidden");
      } else {
        navLinks.classList.add("hidden");
      }
    },
    openModal(modal) {
      bus.emit("openModal", {
        modal,
      });
    },
    async logout() {
      const error = await this.userStore.logout();
      if (error && error.status !== 401) {
        bus.emit("openModal", {
          modal: "error",
          params: error,
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <div
      id="navbar"
      class="fixed flex justify-between items-start h-20 top-0 right-0 left-0 bg-white shadow z-10 px-4"
    >
      <router-link to="/">
        <img src="/static/airbnb-icon.png" class="mt-5 sm:ml-12 h-10 p-1" />
      </router-link>
      <ul
        id="navbar-links"
        class="hidden sm:flex mt-20 sm:mt-0 flex-col sm:flex-row justify-around bg-white shadow-md sm:shadow-none"
      >
        <router-link
          v-for="route in routes"
          :key="route.text"
          data-cy="navbarButton"
          :to="route.to"
          class="pt-6 sm:pt-8 mb-4 sm:mb-0 px-3 font-bold text-sm text-gray-800 hover:text-airbnbRed tracking-wide cursor-pointer border-t-4 border-solid border-transparent"
        >
          {{ $t(route.text) }}
        </router-link>
        <li
          v-for="modal in modals"
          :key="modal.name"
          data-cy="navbarButton"
          class="pt-6 sm:pt-8 mb-4 sm:mb-0 px-3 font-bold text-sm text-gray-800 hover:text-airbnbRed tracking-wide cursor-pointer border-t-4 border-solid border-transparent"
          @click="openModal(modal.name)"
        >
          {{ $t(modal.text) }}
        </li>
        <li
          v-if="loggedIn"
          class="pt-6 sm:pt-8 mb-4 sm:mb-0 px-3 font-bold text-sm text-gray-800 hover:text-airbnbRed tracking-wide cursor-pointer border-t-4 border-solid border-transparent"
          @click="logout"
        >
          {{ $t("components.navbar.logout") }}
        </li>
      </ul>
      <button
        id="navbar-burger"
        class="sm:hidden bg-white text-gray-600 border border-solid border-gray-600 rounded focus:outline-none px-3 py-2 top-0 right-0 mt-6"
        @click="burgerClickHandler"
      >
        <font-awesome-icon icon="bars" />
      </button>
    </div>
    <div id="navbar-placeholder" class="h-20" />
  </div>
</template>

<style scoped>
#navbar-links > li.router-link-exact-active {
  @apply border-t-4 border-solid border-airbnbRed;
}

#navbar-burger:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

#navbar-burger:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
</style>
